import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { EpdkSideBarModeDirective } from './side-bar-mode.directive';
import { EpdkSideBarComponent } from './side-bar.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule
  ],
  declarations: [EpdkSideBarComponent, EpdkSideBarModeDirective],
  exports: [EpdkSideBarComponent, EpdkSideBarModeDirective]
})
export class EpdkSideBarModule { }